import { Tabs, Typography } from "antd";
import { ContainerComponent } from "../../../components";
import { Roles, useAuth } from "../../../providers";
import "../css/admin.view.css";
import { DevBoostFormView } from "./dev-boost/views/dev-boost-form.view";
import { CreateUseCaseView } from "./use-cases/create-use-case.view";
import { InteractiveWorkshopView } from "./workshops/views/interactive-workshop.view";

const onChange = (key) => {
  console.log(key);
};
const items = [
  {
    key: "use-cases",
    label: "Casos de uso",
    children: <CreateUseCaseView />,
  },
  {
    key: "interactive-workshop",
    label: "Taller interactivo",
    children: <InteractiveWorkshopView />,
  },
  {
    key: "dev-boost",
    label: "Dev Boost",
    children: <DevBoostFormView />,
  },
];

export const AdminView = () => {
  const { user } = useAuth();

  let userText = "";
  let userTextSpan = "";

  // Filtra los tabs según el rol del usuario
  const filteredItems =
    user?.role === Roles.ADMIN
      ? items
      : user?.role === Roles.COPILOT
        ? items.filter((item) => item.key === "dev-boost")
        : items.filter((item) => item.key === "interactive-workshop");

  if (user?.role === Roles.ADMIN) {
    userTextSpan = "Admin";
    userText = "Administrador";
  } else {
    userTextSpan = "User";
    userText = "Usuario";
  }

  return (
    <ContainerComponent style={{ width: "100%", height: "100%" }}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "start", marginBottom: 16 }}>
        <Typography.Text style={{ fontSize: "14px", color: "#8c8c8c", marginBottom: "-4px" }}>
          {userTextSpan}
        </Typography.Text>
        <Typography.Title level={2} style={{ color: "var(--color-primary)", margin: 0 }}>
          {userText}
        </Typography.Title>
      </div>
      <Tabs
        defaultActiveKey="1"
        tabBarGutter={8}
        items={filteredItems}
        onChange={onChange}
        className="custom-tabs"
        tabBarStyle={{
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          padding: "8px",
          marginBottom: 30,
          display: "flex",
          justifyContent: "space-between",
        }}
      />
    </ContainerComponent>
  );
};

export const Adminroute = "/admin";
